export const operationsMessages = {
  domainsLoadFailed: 'Failed to load domains',
  domainRequired: 'Domain is required',
  domainUpdated: 'Domain updated',
  domainCreated: 'Domain created',
  defaultDomainUpdated: 'Default domain updated',
  domainDeleted: 'Domain deleted',
  addDomain: 'Add Domain',
  editDomain: 'Edit Domain',
  activeDomainSummary: '{count} active domains',
  registered: 'Registered',
  defaultLabel: 'Default',
  noDomains: 'No domains registered',
  domain: 'Domain',
  setDefault: 'Set Default',
  useDefaultDomain: 'Use as default short domain',
  create: 'Create',
  deleteDomain: 'Delete Domain',
  deleteDomainConfirm:
    'Delete "{domain}" from the domain catalog? Existing links keep their stored domain value.',
  healthSubtitle: 'Manual target URL checks',
  lastChecked: 'Last checked {date}',
  batchSize: 'Batch Size',
  checkActiveLinks: 'Check Active Links',
  checked: 'Checked',
  healthy: 'Healthy',
  broken: 'Broken',
  checkUrl: 'Check URL',
  urlRequired: 'URL is required',
  checkedLinks: 'Checked {count} links',
  urlChecked: 'URL checked',
  noHealthChecks: 'No health checks run yet',
  target: 'Target',
  http: 'HTTP',
  time: 'Time',
  finalUrl: 'Final URL',
  action: 'Action',
  editLinkAction: 'Edit link',
  openTarget: 'Open target',
  healthyStatus: 'healthy',
  warningStatus: 'warning',
  brokenStatus: 'broken',
  linksUnit: '{count} links',
  groupsLoadFailed: 'Failed to load groups',
  groupsSummary: '{count} campaign and project groups',
  addProject: 'Add Project',
  addCampaign: 'Add Campaign',
  campaigns: 'Campaigns',
  projects: 'Projects',
  groupedLinks: 'Grouped Links',
  type: 'Type',
  allGroups: 'All groups',
  noGroups: 'No groups found',
  group: 'Group',
  lastClicked: 'Last Clicked',
  viewLinks: 'View links',
  editGroup: 'Edit Group',
  createGroup: 'Create Group',
  groupColor: 'Group color',
  deleteGroup: 'Delete Group',
  nameRequired: 'Name is required',
  groupUpdated: 'Group updated',
  groupCreated: 'Group created',
  groupDeleted: 'Group deleted',
  deleteGroupConfirm:
    'Delete {type} "{name}"? The {tag} tag will also be removed from {count} links.',
  countryRule: 'Country',
  deviceRule: 'Device',
  browserRule: 'Browser',
  refererRule: 'Referer',
  languageRule: 'Language',
  weightedRule: 'Weighted / A-B',
  unknownLink: 'Unknown link',
  rulesLoadFailed: 'Failed to load redirect rules',
  rulesSummary: '{total} rules · {enabled} enabled',
  addRule: 'Add Rule',
  enabled: 'Enabled',
  weighted: 'Weighted',
  types: 'Types',
  allLinks: 'All links',
  noRules: 'No redirect rules yet',
  match: 'Match',
  priority: 'Priority',
  editRule: 'Edit Redirect Rule',
  addRedirectRule: 'Add Redirect Rule',
  selectLink: 'Select a link',
  ruleType: 'Rule Type',
  targets: 'Targets',
  targetsHint: 'One URL per line, with an optional weight after |',
  matchValues: 'Match Values',
  commaNewline: 'Comma or newline separated',
  targetUrl: 'Target URL',
  deleteRule: 'Delete Redirect Rule',
  deleteRuleConfirm: 'Delete this {type} rule?',
  linkRequired: 'Link is required',
  invalidPriority: 'Priority must be a non-negative integer',
  invalidTargets: 'Targets must use valid URLs and positive weights',
  matchRequired: 'Match values are required',
  invalidTargetUrl: 'Target URL must be http or https',
  ruleUpdated: 'Redirect rule updated',
  ruleCreated: 'Redirect rule created',
  ruleDeleted: 'Redirect rule deleted',
  tokensLoadFailed: 'Failed to load API tokens',
  activeTokens: '{count} active tokens',
  createToken: 'Create Token',
  adminTokens: 'Admin Tokens',
  revoked: 'Revoked',
  noTokens: 'No API tokens yet',
  scopes: 'Scopes',
  lastUsed: 'Last Used',
  revoke: 'Revoke',
  tokenCreated: 'API token created',
  tokenRevoked: 'API token revoked',
  tokenCopied: 'Token copied',
  createApiToken: 'Create API Token',
  newApiToken: 'New API Token',
  automationPlaceholder: 'Automation, backup script, reporting',
  copyAction: 'Copy',
  done: 'Done',
  revokeToken: 'Revoke API Token',
  revokeTokenConfirm: 'Revoke "{name}"? Existing requests using this token will stop working.',
  backupsLoadFailed: 'Failed to load backups',
  backupCreated: 'Backup created: {name}',
  backupRecordsCount: '{count} backup records',
  createBackup: 'Create Backup',
  r2NotConfigured: 'R2 bucket binding is not configured for this Worker.',
  completed: 'Completed',
  storedSize: 'Stored Size',
  latest: 'Latest',
  retentionPolicy: 'Retention',
  retentionPolicyValue: '{count} days',
  noBackups: 'No backups yet',
  storage: 'Storage',
  size: 'Size',
  restoreAction: 'Restore',
  restoreBackup: 'Restore Backup',
  restorePreviewHelp: 'Preview the restore plan before applying changes.',
  conflictStrategy: 'Conflict Strategy',
  overwriteWarning:
    'Overwrite will mutate existing links. Linketry creates a pre-restore R2 backup before applying changes.',
  createAction: 'Create',
  overwriteAction: 'Overwrite',
  renameAction: 'Rename',
  skipAction: 'Skip',
  invalidAction: 'Invalid',
  rulesLabel: 'Rules',
  slug: 'Slug',
  restoreComplete:
    'Restore complete: {created} created, {overwritten} overwritten, {renamed} renamed',
  completedStatus: 'completed',
  failedStatus: 'failed',
  pendingStatus: 'pending',
  bytesUnit: 'B',
  readScope: 'Read',
  writeScope: 'Write',
  adminScope: 'Admin',
  operationsDashboard: 'Operations',
  operationsSubtitle: 'Backup freshness, scheduled monitoring, deployment capabilities, and current target health.',
  backupFreshness: 'Backup Freshness',
  backupFresh: 'Fresh · {date}',
  backupStale: 'Stale · {date}',
  noCompletedBackup: 'No completed backup',
  scheduledMonitoring: 'Scheduled Monitoring',
  monitoringEnabledCount: 'Enabled · {count} links/run',
  monitoringDisabled: 'Disabled',
  configured: 'Configured',
  notConfigured: 'Not configured',
  deploymentHealth: 'Deployment Health',
  workerResponding: 'Worker responding',
  unavailable: 'Unavailable',
  targetHealthSnapshot: 'Target Health Snapshot',
  targetHealthSnapshotHint: 'Runs a manual check only when requested; results are kept in this page until refresh.',
  checkNow: 'Check Now',
  noHealthSnapshot: 'Run a check to see current warning and broken targets.',
  allCheckedTargetsHealthy: 'All {count} checked targets are healthy.',
  activeHealthAlerts: 'Active Health Alerts',
  activeHealthAlertsHint: 'Persisted consecutive failures from scheduled checks.',
  lastAlertAt: 'Last alert: {date}',
  noActiveHealthAlerts: 'No active scheduled health alerts.',
  alertedStatus: 'Alerted',
  consecutiveFailuresCount: '{count} consecutive failures',
  scheduledHealthHistory: 'Scheduled Health History',
  scheduledHealthHistoryHint: 'Latest persisted results from scheduled checks. Up to 200 target checks are retained.',
  noScheduledHealthHistory: 'No scheduled target checks have been recorded yet.',
  failureCount: 'Failures',
  checkedAt: 'Checked At',
  millisecondsUnit: 'ms',
  fallbackUrl: 'Fallback',
} as const;
